import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// styles are in the theme

export { Tab, Tabs };
